<template>
  <div class="app">
    <div class="headerSection">
      <div id="sticky-header" class="row headerSection--sticky">
        <div class="headerSection--header container">
          <div class="headerSection--header__logo">
            <a class="a-Link--Blue" href="/"><img v-bind:src="seratoLogo" alt="Serato" /></a>
          </div>
        </div>
        <MobileNavTotalOrder v-if="showOrderTotal" />
      </div>

      <div id="header-checkout" class="headerSection--checkout">
        <div class="container">
          <div class="headerSection--checkout__caption">
            <h1>{{ headerCaption }}</h1>
          </div>
          <div class="headerSection--checkout__navBackButton">
            <router-link class="a-Link--Blue" v-if="this.$route.path === '/payment'" to="/cart">
              <i class="far fa-angle-left" aria-hidden="true"></i> back
            </router-link>
            <a class="a-Link--Blue" v-else-if="!inAppPurchase" v-bind:href="referrerUrl">
              <i class="far fa-angle-left" aria-hidden="true"></i> back
            </a>
            <div v-else><br></div><!-- we need this empty for the mobile sticky -->
          </div>
        </div>
      </div>

    </div>
    
    <Message ref="messageContainer"/>

    <transition name="fade">
      <div class="container">
        <router-view class="router-view"></router-view>
      </div>
    </transition>

    <modal-dialog
      v-show="loading"
      ref="modalLoading"
      v-bind:showHeader="false"
      v-bind:showFooter="false"
    >
      <div slot="body">
        <div class="a-spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        Please wait ...
      </div>
    </modal-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import Message from './molecules/Message.vue'
import MobileNavTotalOrder from './molecules/MobileNavTotalOrder.vue'

// code split/lazy load the ModalDialog
const ModalDialog = Vue.component('ModalDialog', function (resolve) {
  require(['./organisms/ModalDialog.vue'], resolve)
})

export default {
  computed: mapState({
    seratoLogo: state => state.globalstate.seratoLogo,
    referrerUrl: state => state.globalstate.referrerUrl,
    headerCaption: state => state.globalstate.headerCaption,
    showOrderTotal: state => state.globalstate.showOrderTotal,
    loading: state => state.globalstate.loadingStack.length,
    inAppPurchase: state => state.globalstate.inAppPurchase
  }),

  watch: {
    '$route' (to, from) {
      // unfortunately there is a difference between order and payment pages.
      // order doesn't have the view order and recap of your cart.
      // means the header got a different size and if we want to make the top part of the header sticky
      // we have to update the margin from the bottom part of the header to keep it consistent.
      this.$nextTick(() => this.handleResize())
    }
  },
  components: {
    ModalDialog,
    Message,
    MobileNavTotalOrder
  },

  data () {
    return {
      debugRoute: window.debugEnv // enable the route-lin for non production enviroments
    }
  },
  methods: {
    handleResize () {
      // Get the header
      const header = document.getElementById('sticky-header')
      // if we have orderTotal displayed we need to add a margin top to 20px
      // as no margin bottom should be set through the ordertotal on sticky.
      const marginTop = 5
      // if (this.showOrderTotal) {
      //   marginTop = 20
      // }
      document.getElementById('header-checkout').style.margin = (header.offsetHeight + marginTop) + 'px 0 0 0'
    }
  },
  mounted () {
    this.$store.dispatch('cart/fetch')
    this.$store.dispatch('user/fetch')
    this.handleResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize)
    })
  }
}
</script>

<style lang="scss">
  @import "../../sass/global.scss";
</style>



// WEBPACK FOOTER //
// App.vue?5bcf0994